
	import { Component, Vue } from 'vue-property-decorator';
	import alertServiceModule, { AlertServiceModule } from '@/HostApp/services/AlertService/AlertServiceModule';
	import ViewportWrapper from '@/HostApp/ui/system/ViewportWrapper.vue';

	@Component({
		components: { ViewportWrapper }
	})
	export default class AlertNode extends Vue {
		protected get alertService(): AlertServiceModule {
			return alertServiceModule;
		}

		protected get alerts(): Array<APS.IAlertMessage> {
			return alertServiceModule.currentApplicationMessages;
		}

		protected handleRemoveAlert(idx: number): void {
			alertServiceModule.removeMessage(idx);
		}
	}
